// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"175":"2af7f9c1","233":"ca05d158","369":"d78ff23c","936":"f5a90d91"}[chunkId] + ".css";
};